export default __webpack_public_path__ + "static/media/no-data-amico.61d4e8ac.svg";